import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import { HomeStatistics } from './types';

export const HOME_ENDPOINTS = {
  getStatistics: '/api/v1/Route/Route/Statistic',
};

export const getStatistics = (): ApiPromise<
  DataResponse<HomeStatistics>,
  ErrorResponse
> =>
  API.post<DataResponse<HomeStatistics>, ErrorResponse>(
    HOME_ENDPOINTS.getStatistics,
    {},
  );
